export * from './app-dealersidebar.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-dealersidebar/index.ts